export const ASSISTANT_PERSONALITIES = [
  { id: 'default', labelKey: 'personalityDefault', hintKey: 'personalityDefaultHint' },
  { id: 'pessimistic', labelKey: 'personalityPessimistic', hintKey: 'personalityPessimisticHint' },
  { id: 'robot', labelKey: 'personalityRobot', hintKey: 'personalityRobotHint' },
  { id: 'listener', labelKey: 'personalityListener', hintKey: 'personalityListenerHint' },
  { id: 'geek', labelKey: 'personalityGeek', hintKey: 'personalityGeekHint' }
];

export const TONE_TAG_PRESETS = [
  { id: 'humorous', labelKey: 'toneHumorous' },
  { id: 'playful', labelKey: 'tonePlayful' },
  { id: 'sarcastic', labelKey: 'toneSarcastic' },
  { id: 'formal', labelKey: 'toneFormal' },
  { id: 'warm', labelKey: 'toneWarm' },
  { id: 'direct', labelKey: 'toneDirect' }
];

export const MEMORY_SUMMARY_MAX = 400;
export const APP_VERSION = '0.1.0';
